import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const TOKEN_INIT = () => localStorage.getItem('od-token');

export default new Vuex.Store({
  state: {
    user: null,
    token: TOKEN_INIT(),
    columnList: null,
    newsList: null,
  },
  getters: {
    token: (s) => s.token,
    user: (s) => s.user,
    columnList: (s) => s.columnList,
    newsList: (s) => s.newsList,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem('od-token', token);
      } else {
        localStorage.removeItem('od-token');
      }
    },
    setRefreshToken(s, token) {
      if (token) {
        localStorage.setItem('od-refresh-token', token);
      } else {
        localStorage.removeItem('od-refresh-token');
      }
    },
    setUser(state, user) {
      state.user = user;
    },
    setColumnList(state, list) {
      state.columnList = list;
    },
    setNewsList(state, list) {
      state.newsList = list;
    },
  },
  actions: {
    async me({ commit }) {
      await this._vm.axios.get('/admin/me').then(
        (r) => {
          commit('setUser', r.data);
        },
        () => {
          commit('setToken', null);
          commit('setUser', null);
        },
      );
    },
    async getColumnList({ commit }) {
      await this._vm.axios({ url: '/api/media/column', type: 'GET' })
        .then(({ data }) => {
          commit('setColumnList', data);
        })
        .catch(() => {
          commit('setColumnList', null);
        });
    },
    async getNewsList({ commit }) {
      await this._vm.axios({ url: '/api/media/news', type: 'GET' })
        .then(({ data }) => {
          commit('setNewsList', data);
        })
        .catch(() => {
          commit('setNewsList', null);
        });
    },
    signout({ commit }) {
      commit('setToken', null);
      commit('setUser', null);
    },
  },
  modules: {},
});
